import * as React from "react";
const SvgGroupWorkOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    <circle cx={8} cy={14} r={2} />
    <circle cx={12} cy={8} r={2} />
    <circle cx={16} cy={14} r={2} />
  </svg>
);
export default SvgGroupWorkOutlined;
